import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { useMount } from "react-use";
import { useStores } from "../hooks";
import { getLockerInfo, closeDoor } from "../service";
import Header from "../component/Header";
import Footer from "../component/Footer";
import UserInfo from "../component/UserInfo";
import CountDown from "../component/CountDown";
import Locker from "../component/Locker";

const Open = () => {
  const { formatMessage } = useIntl();
  const { sessionStore } = useStores();
  const [code, setCode] = useState("");
  const [completed, setCompleted] = useState(false);
  const [continued, setContinued] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useMount(() => {
    const ldid = sessionStore.takeitem.locker_detail_id;
    if (ldid !== 0 && ldid !== null && ldid !== undefined) {
      sessionStore.lockerDetail.forEach((item) => {
        if (item.id === ldid) {
          setCode(item.code);
        }
      });
      /*
      if (sessionStore.debug) {
        return;
      }
      openDoor(ldid).then((flag) => {
        if (!flag) {
          setErrorMessage(
            formatMessage({
              id: "hyvendor.error.syserror",
            })
          );
        }
      });
      */
    }
  });

  const handleCloseDoor = async (isContinue: boolean) => {
    const ldid = sessionStore.takeitem.locker_detail_id;
    if (ldid !== 0 && ldid !== null && ldid !== undefined) {
      if (sessionStore.debug) {
        if (isContinue) {
          getLockerInfo()
            .then((res) => {
              sessionStore.setLocker(
                res.locker_detail,
                res.locker.locker_tier,
                res.locker.locker_column,
                res.items
              );
            })
            .finally(() => {
              setContinued(true);
            });
        } else {
          setCompleted(true);
        }
        return;
      }
      closeDoor(ldid).then((flag) => {
        if (flag) {
          if (isContinue) {
            getLockerInfo()
              .then((res) => {
                sessionStore.setLocker(
                  res.locker_detail,
                  res.locker.locker_tier,
                  res.locker.locker_column,
                  res.items
                );
              })
              .finally(() => {
                setContinued(true);
              });
          } else {
            setCompleted(true);
          }
        } else {
          setErrorMessage(
            formatMessage({
              id: "hyvendor.error.dooropened",
            })
          );
        }
      });
    }
  };

  return (
    <>
      {continued ? (
        <Navigate to="/book" />
      ) : completed ? (
        <Navigate to="/logout" />
      ) : (
        <>
          <div
            className="overlay"
            style={{
              display: errorMessage !== "" ? "block" : "none",
            }}
          >
            <div className="info">
              <section className="error">{errorMessage}</section>
              <div className="btns">
                <button
                  type="button"
                  className="btn confirm"
                  onClick={(e) => {
                    setErrorMessage("");
                  }}
                >
                  {formatMessage({ id: "hyvendor.button.close" })}
                </button>
              </div>
            </div>
          </div>
          <div className="page-set">
            <Header />
            <div className="Main">
              <UserInfo reader={sessionStore.userInfo} />
              <section className="Menu"></section>
              <h3 className="Title">
                {formatMessage({ id: "hyvendor.title.open" })}
              </h3>
              <CountDown />
              <Locker
                list={sessionStore.lockerDetail}
                tier={sessionStore.lockerTier}
                column={sessionStore.lockerColumn}
                items={sessionStore.lockerItems}
                opened={sessionStore.takeitem}
                locked={true}
              />

              <section className="finished">
                <div className="scroll">
                  <section className="info">
                    {code !== "" && (
                      <p className="opened">
                        {formatMessage({ id: "hyvendor.message.open1" })}
                        <span>{code}</span>
                        {formatMessage({ id: "hyvendor.message.open2" })}
                        <br />
                      </p>
                    )}
                  </section>
                </div>
                <section className="btns">
                  <button
                    type="button"
                    className="btn next"
                    onClick={() => handleCloseDoor(true)}
                  >
                    {formatMessage({ id: "hyvendor.button.donecontinue" })}
                  </button>
                  &nbsp;
                  <button
                    type="button"
                    className="btn cancel"
                    onClick={() => handleCloseDoor(false)}
                  >
                    {formatMessage({ id: "hyvendor.button.donetake" })}
                  </button>
                </section>
              </section>
            </div>
          </div>
          <Footer />
        </>
      )}
    </>
  );
};

export default Open;
